/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.EmployeeCategories {
  "use strict";

  export class EmployeeCategoriesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService) {

      super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
    }

    initializeContext(): void {
      this.entityType = 'EmployeeCategory';
      this.baseEndpoint = this.appSettings.API_ENDPOINTS.employeeCategory;
      this.sectionTemplatePath = "app/plugins/employeeCategories/sectionViews/";
      this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEECATEGORY_TAB_MAIN, true, true, false, false, true);
    }

    initializeSections(): void {
      this.initializeContext();
      if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEECATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
        this.sections.push(new MainSection(0, "SECTION_SERVICES_MAIN", "main.html", true, false, this.baseEndpoint, "",
            this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.EmployeeCategoryMain, null, this.securityKeys.DATA_EMPLOYEECATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
    }

    initializeHeader(model:any): void {
      this.headerContent = model.displayName;
      this.businessTypeDetail = model.businessTypeDetail;
    }

    postCopy(): void {
        super.postCopy();
        let model = this.castModel<Model.EmployeeCategory>();
        model.displayName = undefined;
        model.employees = [];
    }

    get allowTakeOwnership(): boolean {
        return false;
    }
  }
}